import React from 'react'
import Image from 'next/image'
import { CustomLoader } from '@/components/blocks/custom-loader'

type PreviewImageProps = {
  loading: boolean
  imageSrc: string
}

const PreviewImage: React.FC<PreviewImageProps> = React.memo(
  ({ loading, imageSrc }) => {
    return (
      <div className='flex min-h-full min-w-full items-center justify-center rounded-xl border-2 border-dashed border-gray-300 p-5'>
        <div className='relative mx-auto flex max-h-[600px] max-w-[600px] flex-col items-center justify-center space-y-4'>
          <Image
            alt='Preview image'
            src={imageSrc}
            width={600}
            height={600}
            className='max-h-[500px] w-full max-w-[500px] object-contain opacity-50'
          />
          {loading && (
            <div className='absolute top-5 flex w-full items-center justify-center'>
              <CustomLoader />
            </div>
          )}
        </div>
      </div>
    )
  }
)

PreviewImage.displayName = 'PreviewImage'

export { PreviewImage }
